import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { LocalStorageRefService } from './local-storage-ref.service';

interface LocalStorageData {
  activeResultsEvent: number | null;
  canUseCookies?: boolean;
}

const initialData: LocalStorageData = {
  activeResultsEvent: null,
};

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private _localStorage: Storage;
  private _myData$ = new BehaviorSubject<LocalStorageData>(initialData);
  public data$ = this._myData$.asObservable();

  constructor(private _localStorageRefService: LocalStorageRefService) {
    this._localStorage = _localStorageRefService.localStorage;
    this.loadInfo();

    const data = {
      ...initialData,
      ...this._myData$.value,
    };

    this.setInfo(data);
  }

  public setInfo(data: Partial<LocalStorageData>): void {
    const myData = {
      ...this._myData$.value,
      ...data,
    };
    const jsonData = JSON.stringify(myData);
    this._localStorage.setItem('myData', jsonData);
    this._myData$.next(myData);
  }

  public loadInfo(): void {
    const data = JSON.parse(<string>this._localStorage.getItem('myData'));
    this._myData$.next(data);
  }

  public getInfo(): LocalStorageData {
    return JSON.parse(<string>this._localStorage.getItem('myData'));
  }

  public clearInfo(): void {
    this._localStorage.removeItem('myData');
    this._myData$.next(initialData);
  }
}
